var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathEssentials(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 17V4.55556C6.33333 3.61256 6.70794 2.70819 7.37473 2.0414C8.04153 1.3746 8.9459 1 9.88889 1H15.2222V5M2.77778 33L4.55556 30.3333M31.2222 33L29.4444 30.3333M2.77778 17H31.2222C31.6937 17 32.1459 17.1873 32.4793 17.5207C32.8127 17.8541 33 18.3063 33 18.7778V24.1111C33 25.9971 32.2508 27.8058 30.9172 29.1394C29.5836 30.473 27.7749 31.2222 25.8889 31.2222H8.11111C6.22513 31.2222 4.41639 30.473 3.0828 29.1394C1.7492 27.8058 1 25.9971 1 24.1111V18.7778C1 18.3063 1.1873 17.8541 1.5207 17.5207C1.8541 17.1873 2.30628 17 2.77778 17Z",
    stroke: "var(--brand-color)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathEssentials);
export default __webpack_public_path__ + "static/media/bath_essentials.ef6d1c37a0d5e95ca066fe2f9214e948.svg";
export { ForwardRef as ReactComponent };